/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaListApiResponse,
    MediaListApiResponseFromJSON,
    MediaListApiResponseFromJSONTyped,
    MediaListApiResponseToJSON,
} from './MediaListApiResponse';
import {
    PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOf,
    PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfFromJSON,
    PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfFromJSONTyped,
    PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfToJSON,
} from './PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOf';
import {
    PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummaries,
    PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummariesFromJSON,
    PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummariesFromJSONTyped,
    PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummariesToJSON,
} from './PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummaries';

/**
 * response of GET /prtimes_media_lists/{media_list_id}/selected_media_lists/logs/summaries
 * @export
 * @interface PrtimesMediaListsSelectedMediaListsLogSummariesGetResponse
 */
export interface PrtimesMediaListsSelectedMediaListsLogSummariesGetResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof PrtimesMediaListsSelectedMediaListsLogSummariesGetResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof PrtimesMediaListsSelectedMediaListsLogSummariesGetResponse
     */
    message: string;
    /**
     * 履歴ごとの日付と企業ユーザ名のSummaryのリスト（アコーディオンの中を表示する時に使う）
     * @type {Array<PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummaries>}
     * @memberof PrtimesMediaListsSelectedMediaListsLogSummariesGetResponse
     */
    summaries: Array<PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummaries>;
}

export function PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseFromJSON(json: any): PrtimesMediaListsSelectedMediaListsLogSummariesGetResponse {
    return PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseFromJSONTyped(json, false);
}

export function PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrtimesMediaListsSelectedMediaListsLogSummariesGetResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'summaries': ((json['summaries'] as Array<any>).map(PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummariesFromJSON)),
    };
}

export function PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseToJSON(value?: PrtimesMediaListsSelectedMediaListsLogSummariesGetResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'summaries': ((value.summaries as Array<any>).map(PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummariesToJSON)),
    };
}

